/* eslint-disable */
import React, { useState } from "react";
import { Logo } from "../_components/Imagepath";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { mobilePattern } from "../assets/constant";
import axios from "axios";
import alertify from "alertifyjs";
import "../../node_modules/alertifyjs/build/css/alertify.css";
import "../../node_modules/alertifyjs/build/css/themes/semantic.css";
import { useHistory } from "react-router-dom";

const schema = yup.object({
  name: yup
    .string()
    .required("Phone number required")
    .matches(mobilePattern, "Enter Correct Phone Number")
    .trim(),
  password: yup
    .string()
    .required("Password is required")
    .min(6)
    .trim(),
});

const Login = () => {
  const [eye, seteye] = useState(true);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const histrory = useHistory();

  const inputValues = {
    name: "",
    password: "",
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: inputValues,
  });

  const onSubmit = (data) => {
    console.log("Submitted data:", data);

    console.log(`${BASE_URL}login.php?mobile=${data.name.trim()}`);

    axios
      .get(`${BASE_URL}login.php?mobile=${data.name.trim()}`)
      .then((res) => {
        console.log("res", res);

        const user = res.data[0]; 
        console.log("User data:", user);

        if (user.mobile) {
          if (
            user.mobile == data.name.trim() &&
            user.password == data.password.trim()
          ) {
            if (user.status) {
              // Check if user is an admin
              if (user.user_type === "admin") {
                localStorage.setItem("isauth", "true");
                localStorage.setItem("User", JSON.stringify(user));
                localStorage.setItem("isAdmin", user.user_type);
                console.log("Login successfully");
                alertify.set("notifier", "position", "top-right");
                alertify.success("Login successfully.!");
                histrory.replace("/");
              } else {
                console.log("Your Not Authorized Person");
                alertify.set("notifier", "position", "top-right");
                alertify.error("Your Not Authorized Person");
              }
            } else {
              console.log("Account Is Inactive.");
              alertify.set("notifier", "position", "top-right");
              alertify.error("Account is not active!");
            }
          } else {
            console.log("Invalid password.");
            alertify.set("notifier", "position", "top-right");
            alertify.error("Invalid password.!");
          }
        } else {
          console.log("invalid mobile number");
          alertify.set("notifier", "position", "top-right");
          alertify.error("invalid mobile number");
        }
      })
      .catch((err) => {
        console.error("Error during login:", err);
        console.log("Something went wrong. Please try again.");
        console.log("invalid mobile number");
        alertify.set("notifier", "position", "top-right");
        alertify.error("Something went wrong. Please try again.");
      });
  };

  const onEyeClick = () => {
    seteye(!eye);
  };

  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <img className="img-fluid logo-dark mb-2" src={Logo} alt="Logo" />
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Login</h1>
                  <p className="account-subtitle">Access to our dashboard</p>
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="input-block mb-3 input_text">
                        <label className="form-control-label">
                          Mobile Number
                        </label>
                        <Controller
                          name="name"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <input
                              className={`form-control  ${
                                errors?.name ? "error-input" : ""
                              }`}
                              type="text"
                              placeholder="Enter Phone Number"
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                            />
                          )}
                        />

                        <small className="text-danger">
                          {errors?.name?.message}
                        </small>
                      </div>
                      <div className="input-block mb-3 input_text login-eye">
                        <label className="form-control-label">Password</label>
                        <Controller
                          name="password"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="pass-group">
                              <input
                                type={eye ? "password" : "text"}
                                className={`form-control  ${
                                  errors?.password ? "error-input" : ""
                                }`}
                                value={value}
                                onChange={onChange}
                                autoComplete="false"
                                placeholder="Enter Password"
                              />
                              <span
                                onClick={onEyeClick}
                                className={`fas toggle-password ${
                                  eye ? "fa-eye-slash" : "fa-eye"
                                }`}
                              />
                            </div>
                          )}
                        />

                        <small className="text-danger">
                          {errors?.password?.message}
                        </small>
                      </div>
                      <button
                        className="btn btn-lg btn-block w-100 btn-primary w-100"
                        type="submit"
                      >
                        Login
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;
